import React, { Component } from 'react'

import ListItem from './ListItem'

const StatusListCycle = ({fetcher}) => {
  return <ListItem fetcher={fetcher} />
}

export default StatusListCycle
